module.exports = __webpack_public_path__ + "img/6.5e235c13.jpg";